import supabase from "../supabaseClient";
import { isCompletedShipmentStatus } from "./shipmentProgress";

export const formatInactiveShipmentDateTime = (value) => {
  if (!value) return "Not set";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not set";
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Manila",
  });
};

export const getInactiveShipmentsRoute = (pathname) => {
  if (pathname.startsWith("/superAdmin/")) return "/superAdmin/shipment-management";
  if (pathname.startsWith("/admin/")) return "/admin/shipment-management";
  if (pathname.startsWith("/corporate/")) return "/corporate/corporate-shipment-management";
  return "";
};

export const fetchUserInactiveShipments = async (userId) => {
  const numericUserId = Number(userId || 0);
  if (!numericUserId) return [];

  const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();

  const { data, error } = await supabase
    .from("shipments")
    .select(
      "shipment_id, tracking_no, job_order, status, status_updated_at, shipper_name, receiver_name, current_user_name, user_id"
    )
    .eq("user_id", numericUserId)
    .not("status_updated_at", "is", null)
    .lt("status_updated_at", oneDayAgo)
    .order("status_updated_at", { ascending: false });

  if (error) throw error;

  return (data || []).filter(
    (shipment) =>
      !isCompletedShipmentStatus(String(shipment.status || "").trim())
  );
};
